import React, { Fragment } from 'react';
import ItemwiseReportView from './ItemwiseReportView';

// Thin route entry — the V3 shell lives inside the view.
const ItemwiseReport = () => (
    <Fragment>
        <ItemwiseReportView />
    </Fragment>
);

export default ItemwiseReport;
